import { connect } from 'react-redux';
import Chats from './Chats';

const mapStateToProps = state => ({
    displayName: state.spid.displayName,
    familyName: state.spid.familyName,
    givenName: state.spid.givenName,
    email: state.login.email,
    loginInitialized: state.login.initialized,
});

export default connect(mapStateToProps)(Chats);
